import ActionTypes from './ActionTypes';

const DEFAULT_ALERTS_DATA = {
  alertList: [],
  alertRulesList: [],
  metricsList: []
};

export default function alertsReducer(state = DEFAULT_ALERTS_DATA, action) {
  switch (action.type) {
    case ActionTypes.SET_ALERT_LIST:
      return {
        ...state,
        alertList: action.alerts
      };

    case ActionTypes.DELETE_ALERT:
      return {
        ...state,
        alertList: state.alertList.filter((alert) => alert.id !== action.id)
      };

    case ActionTypes.SET_ALERT_RULES_LIST:
      return {
        ...state,
        alertRulesList: action.alertRules
      };

    case ActionTypes.SET_RULES_METRICS_LIST:
      return {
        ...state,
        metricsList: action.metrics
      };

    case ActionTypes.ADD_RULE:
      return {
        ...state,
        alertRulesList: [action.rule, ...state.alertRulesList]
      };

    case ActionTypes.DUPLICATE_RULE:
      return {
        ...state,
        alertRulesList: [action.rule, ...state.alertRulesList]
      };

    case ActionTypes.EDIT_RULE:
      return {
        ...state,
        alertRulesList: state.alertRulesList.map((rule) => {
          if (rule.id === action.rule.id) {
            return action.rule;
          }
          return rule;
        })
      };

    default:
      return state;
  }
}
